document.addEventListener('click', function(event){
  if(event.target.classList.contains('trigger-loading-spinner')){
    $('.loading-overlay').show();
  }

  if(event.target.classList.contains('query-string-update')){
    $('.loading-overlay').show();
  }
});


